/**
 * Created by ostapenko.r on 9/23/2014.
 */

angular.module('flipto.components.common.fieldEditors', []);